import React from 'react';
import { Accordion, AccordionHeader, AccordionBody, Typography, } from '@one-thd/sui-atomic-components';
import { useAddManageUsers } from '../../../../../hooks/use-add-manage-users';
export var StepTwo = function () {
    var isPartOfRunnerAllowance = useAddManageUsers().isPartOfRunnerAllowance;
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var handleChange = function (event, isExpanded) {
        setExpanded(isExpanded);
    };
    return (React.createElement("div", { "data-testid": "upload-instructions-step2" },
        React.createElement("div", { className: "sui-flex sui-mb-2" },
            React.createElement("div", { className: "sui-min-w-[60px] sui-text-lg" },
                React.createElement(Typography, { weight: "bold" }, "Step 2:")),
            React.createElement(Typography, null, "Fill in your users' data. Limit 500 users per file. All columns are required.")),
        React.createElement("div", { className: "sui-mb-8" },
            React.createElement(Accordion, { expanded: expanded, onChange: handleChange },
                React.createElement(AccordionHeader, null, "How to assign user roles"),
                React.createElement("div", { className: "sui-border-solid sui-border-1 sui-border-primary sui-border-t-0" },
                    React.createElement(AccordionBody, null,
                        React.createElement("div", { className: "sui-text-base" },
                            React.createElement("div", { className: "sui-mb-4" },
                                React.createElement(Typography, null, "Label each user's role according to the level of account access they should have.")),
                            isPartOfRunnerAllowance && (React.createElement("div", { className: "sui-mb-3" },
                                React.createElement(Typography, null,
                                    React.createElement(Typography, { component: "span", weight: "bold" },
                                        "Runner:",
                                        ' '),
                                    "No account access. Limited to in-store purchases using assigned Pro Allowances."))),
                            React.createElement("div", { className: "sui-mb-3" },
                                React.createElement(Typography, null,
                                    React.createElement(Typography, { component: "span", weight: "bold" },
                                        "Purchaser:",
                                        ' '),
                                    "Limited account access. Can make online and in-store purchases using their own payment methods and can be assigned Pro Allowances.")),
                            React.createElement(Typography, null,
                                React.createElement(Typography, { component: "span", weight: "bold" },
                                    "Admin:",
                                    ' '),
                                "Full account access. Can update account information, manage online and in-store purchases, and assign Pro Allowances."))))))));
};
